import { render, staticRenderFns } from "./symbol-modifiers.vue?vue&type=template&id=31521dac&scoped=true&"
import script from "./symbol-modifiers.vue?vue&type=script&lang=js&"
export * from "./symbol-modifiers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31521dac",
  null
  
)

export default component.exports